<template>
  <m-layout>
    <div fill-height class="fill-height" style="width:100%">
    <m-calendar></m-calendar>
    </div>
  </m-layout>
</template>

<script>
import Calendar from '../components/calendar/calendar';
import CalendarMixin from '@/mixins/calendar'
export default {
  name: 'calendar',
  mixins: [CalendarMixin],
  components: {
    'm-calendar': Calendar
  }
}
</script>

<style lang="scss">

</style>
